import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import { ReactHookForm } from '../../components/hook-form/react-hook-form.component';
import { Icons } from '../../assets/icons';
import FormInput from '../../components/hook-form/form-input.component';
import { ApiErrorComponent } from '../../components/api-error.component';
import { useReactHookForm } from '../../hooks/useReactHookForm';
import * as Yup from 'yup';
import { passwordApiKeyStore } from '../../api/password-api-key-store';
import { useSaveData } from '../../hooks/useSaveData';
import { useSnackbar } from '../../hooks/use-snackbar.hook';

const styling = {
  textStyle: { cursor: 'pointer', fontWeight: 'normal', textDecoration: 'underline' },
};
const validationSchema = Yup.object().shape({
  password: Yup.string()
    .required('New password is required')
    // Enforces minimum length
    .matches(/^(?=.*[A-Z])/, 'Password must contain at least one uppercase letter') // Enforces uppercase
    .matches(/^(?=.*[@$!%*?&])/, 'Password must contain at least one special character')
    .min(16, 'Password must be at least 16 characters long'), // Enforces special character
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password')], 'Passwords must match')
    .required('Confirm password is required'),
});
export const ResetForgetPassword = () => {
  const { showSnackbar } = useSnackbar();
  const { isLoading, mutateAsync } = useSaveData<any>(passwordApiKeyStore.setNewPasswordWithToken());
  const form = useReactHookForm({
    defaultValues: {},

    yupSchema: validationSchema,
  });

  const url = window.location.href;
  const token = url.split('token=')[1]?.replace(/["]/g, ''); // Removes quotes (%22)

  const handleSubmit = async (data: any) => {
    mutateAsync({
      data: {
        newPassword: data?.password,
        confirmPassword: data?.confirmPassword,
        resetToken: !token ? '' : token,
      },
    })
      .then((data) => {
        if (data?.data?.userID) {
          // Add a timer (1 seconds delay) before redirecting to the login page
          showSnackbar('Password reset successfully', 'success');
          setTimeout(() => {
            handleForgotPassword();
          }, 1000); // 1000 milliseconds = 1 seconds
        }
      })
      .catch((error) => {
        console.error('Error during password reset:', error);
      });
  };

  const handleForgotPassword = () => {
    window.location.href = '/';
  };

  return (
    <ReactHookForm
      formName="FORGOT_PASSWORD_FORM"
      onSubmit={handleSubmit}
      formContextProps={form}
      // isBusy={isLoading || isLoadingUser}
    >
      <Grid container className="loginform" justifyContent="center" alignItems="center">
        <Grid item xs={4} className="loginWrap">
          <Stack className="brandName">
            <img src={Icons.Logo} alt="SI Track" />
          </Stack>
          <Box>
            <FormInput label="Password" name="password" type="password" maxLength={100} isShrink={true} />
          </Box>
          <Box>
            <FormInput
              label="Confirm password"
              name="confirmPassword"
              type="password"
              maxLength={100}
              isShrink={true}
            />
          </Box>
          {/* <Box>
                        <ApiErrorComponent isError={isError} errorRespnse={error} />
                    </Box> */}
          <Box>
            <Button type="submit" variant="contained" disableElevation size="medium" fullWidth>
              Send
            </Button>
          </Box>
          <Box>
            <Grid
              container
              direction="row"
              sx={{
                justifyContent: 'flex-end',
                alignItems: 'flex-start',
              }}
            >
              <div onClick={handleForgotPassword} className="flex-end">
                <Typography variant="body2" style={styling.textStyle}>
                  back to login
                </Typography>
              </div>
            </Grid>
          </Box>
          <Typography variant="body2" className="loginfooter">
            © {new Date().getFullYear()} Specialty Inspectors, LLC. All Right Reserved.
          </Typography>
        </Grid>
      </Grid>
    </ReactHookForm>
  );
};
